export default {
  gatewayLoaded: false,
  isGameActive: 0,
  socketConnect: null,
  socketKeepAlive: null,
  gameConfig: {},
  gameId: '',
  companyConfig: {},
  apiLocationConfig: {},
  offer: {},
  selected: {
    match: {},
    bet: {},
    outcome: {},
  },
  betTypes: {
    single: {
      id: 3,
      name: 'single',
    },
    combo: {
      id: 1,
      name: 'combo',
    },
  },
  activeBetType: 'combo',
  keyEventTimestamp: '',
  bets: [],
  editBet: {},
  rebet: null,
  bet: {},
  singleStake: 0,
  comboStake: 0,
  potentionalWin: 0,
  foundMatchInBetslip: false,
  translations: {},
  gateway: {},
  globalBetstop: false,
  searchedValue: '',
  searchInputActive: 0,
  ticketPreviewShow: false,
  ticketPreview: null,
  ticketPreviewBetslip: null,
  addingBet: false,
  betslipBlocked: [],
};
